import * as React from "react";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Stack,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LoginIcon from "@mui/icons-material/Login";
import CreateIcon from "@mui/icons-material/Create";

import Image from "../../assets/palacio-salvo-montevideu-uruguai.jpg";
import ImageLogo1 from "../../assets/logo_censo.svg";
import ImageLogo2 from "../../assets/logo_ine.svg";

import {
  login as loginReq,
  register as registerReq,
} from "../../services/accessingRequests";
import { useNavigate } from "react-router-dom";
import { locStor } from "../../services/localStorageManipulation";
import { USER_DATA } from "../../services/constants";
import { useDispatch, useSelector } from "react-redux";
import { saveUserData } from "../../store/slices/userData";
import {
  hideLoadingScreen,
  showLoadingScreen,
} from "../../store/slices/loading";
import { useSnackbar } from "notistack";

const backgroundImgStyles = {
  backgroundImage: `url(${Image})`,

  backgroundPosition: "bottom",
  backgroundSize: "cover",
};

const UserAccess = ({ setApiKey, changePage }) => {
  const [activeTab, setActiveTab] = React.useState("login");
  const [loginUser, setLoginUser] = React.useState(null);
  const [registerUser, setRegisterUser] = React.useState(null);
  const [showPassword, setShowPassword] = React.useState(false);

  const navigateTo = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const setUserData = (dataParam) => {
    dispatch(saveUserData(dataParam));
  };

  const userData = useSelector((state) => state.userData.data);

  const handleChange = (_, tab) => {
    setActiveTab(tab);
  };
  const valuesHandler = {
    login: {
      username: (valueP) => {
        setLoginUser({ ...loginUser, name: valueP });
      },
      pwd: (valueP) => {
        setLoginUser({ ...loginUser, pwd: valueP });
      },
    },
    register: {
      username: (valueP) => {
        setRegisterUser({ ...registerUser, name: valueP });
      },
      pwd: (valueP) => {
        setRegisterUser({ ...registerUser, pwd: valueP });
      },
      pwd2: (valueP) => {
        setRegisterUser({ ...registerUser, pwd2: valueP });
      },
    },
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const registNewUser = async () => {
    if (registerUser.pwd !== registerUser.pwd2) {
      enqueueSnackbar("Las contraseñas deben coincidir", { variant: "error" });
    } else {
      dispatch(showLoadingScreen());
      const currentLocalStoreUserData = locStor.get(USER_DATA);
      const data = await registerReq(registerUser.name, registerUser.pwd);
      if (!(data?.id || false)) {
        dispatch(hideLoadingScreen());
        setRegisterUser({ ...registerUser, name: "", pwd: "", pwd2: "" });
        enqueueSnackbar(data.mensaje, { variant: "error" });
      } else {
        setUserData({
          ...userData,
          ...currentLocalStoreUserData,
          id: data?.id,
          name: registerUser.name,
        });
        setApiKey(data.apiKey);
        enqueueSnackbar("Registrado exitosamente!", { variant: "success" });
        setTimeout(() => {
          enqueueSnackbar(
            "Has ingresado como: " +
              (registerUser.name || "Usuario " + data?.id),
            { variant: "success" }
          );
        }, 400);
        changePage("Dashboard");
        navigateTo("/dashboard");
      }
    }
  };
  const loginHandler = async () => {
    dispatch(showLoadingScreen());
    const currentLocalStoreUserData = locStor.get(USER_DATA);
    const data = await loginReq(loginUser.name, loginUser.pwd);
    if (!(data?.id || false)) {
      dispatch(hideLoadingScreen());
      setLoginUser({ ...loginUser, pwd: "" });
      enqueueSnackbar(data.mensaje, { variant: "error" });
    } else {
      setUserData({
        ...userData,
        ...currentLocalStoreUserData,
        id: data?.id,
        name: loginUser.name,
      });
      enqueueSnackbar(
        "Has ingresado como: " + (loginUser.name || "Usuario " + data?.id),
        { variant: "success" }
      );
      setApiKey(data.apiKey);
      changePage("Dashboard");
      navigateTo("/dashboard");
    }
  };
  React.useEffect(() => {
    if (userData) {
      navigateTo("/dashboard");
    }
  }, []);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ height: { xs: "100vh", md: "90vh" } }}
    >
      <Paper
        elevation={10}
        sx={{
          width: "90%",
          //   width: { xs: "100%", md: "80%" },
          height: { xs: "100%", md: "70%" },
          minHeight: "600px",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          justifyContent="center"
          alignItems="center"
          sx={{ width: "100%", height: "100%" }}
          style={backgroundImgStyles}
        >
          <Stack
            sx={{
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(2px)",
              p: 3,
            }}
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            flexWrap="wrap"
          >
            <Typography
              variant="h1"
              component="h1"
              align="center"
              sx={{
                width: "100%",
                opacity: "0.7",
              }}
            >
              CENSO 2023
            </Typography>
            <Typography
              variant="h4"
              component="h4"
              align="center"
              sx={{
                width: "100%",
                opacity: "0.7",
              }}
            >
              Todos contamos
            </Typography>
            <img
              src={ImageLogo2}
              alt="Logo INE 2023"
              style={{
                width: "50%",
                minWidht: "300px",
              }}
            />
            <img
              src={ImageLogo1}
              alt="Logo Censo 2023"
              style={{
                width: "52%",
                minWidht: "300px",
              }}
            />
          </Stack>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              p: 3,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(2px)",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                boxShadow: "0px 0px 7px 4px rgba(0, 0, 0, 0.8)",
                borderRadius: "8px",
                p: 4,
              }}
            >
              <ToggleButtonGroup
                color="primary"
                value={activeTab}
                exclusive
                onChange={handleChange}
                aria-label="Acceder"
                fullWidth
                sx={{ mb: 4 }}
              >
                <ToggleButton value="login">Logearse</ToggleButton>
                <ToggleButton value="register">Registrarse</ToggleButton>
              </ToggleButtonGroup>

              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-end"
                spacing={4}
                sx={{ width: "100%", height: "100%" }}
              >
                {activeTab === "login" ? (
                  <>
                    <TextField
                      id="loginName"
                      variant="outlined"
                      color="primary"
                      label="usuario"
                      fullWidth
                      value={loginUser?.name || ""}
                      error={false}
                      helperText={false ? "ERROR HERE" : ""}
                      onChange={(e) => {
                        valuesHandler.login.username(e.target.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AccountCircle
                              sx={{
                                opacity: "0.8",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="loginPwd">Contraseña</InputLabel>
                      <OutlinedInput
                        onChange={(e) => {
                          valuesHandler.login.pwd(e.target.value);
                        }}
                        id="loginPwd"
                        value={loginUser?.pwd || ""}
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="mostrar y ocultar contraseña"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              sx={{
                                opacity: "0.8",
                                marginRight: "-8px",
                              }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Contraseña"
                      />
                    </FormControl>

                    <Button
                      variant="contained"
                      startIcon={<LoginIcon />}
                      disabled={
                        !(loginUser !== null && loginUser.name && loginUser.pwd)
                      }
                      onClick={loginHandler}
                    >
                      Entrar
                    </Button>
                  </>
                ) : (
                  <>
                    <TextField
                      id="registerName"
                      variant="outlined"
                      color="primary"
                      label="Nombre de Usuario"
                      fullWidth
                      error={false}
                      helperText={false ? "ERROR HERE" : ""}
                      value={registerUser?.name || ""}
                      onChange={(e) => {
                        valuesHandler.register.username(e.target.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AccountCircle
                              sx={{
                                opacity: "0.8",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <FormControl variant="outlined" fullWidth id="registerPwd">
                      <InputLabel htmlFor="registerPwd">Contraseña</InputLabel>
                      <OutlinedInput
                        value={registerUser?.pwd || ""}
                        onChange={(e) => {
                          valuesHandler.register.pwd(e.target.value);
                        }}
                        id="registerPwd"
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="mostrar y ocultar contraseña"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              sx={{
                                opacity: "0.8",
                                marginRight: "-8px",
                              }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Contraseña"
                      />
                    </FormControl>
                    <FormControl variant="outlined" fullWidth id="registerPwd2">
                      <InputLabel htmlFor="registerPwd">
                        Confirmar Contraseña
                      </InputLabel>
                      <OutlinedInput
                        value={registerUser?.pwd2 || ""}
                        onChange={(e) => {
                          valuesHandler.register.pwd2(e.target.value);
                        }}
                        id="registerPwd"
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="mostrar y ocultar contraseña"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              sx={{
                                opacity: "0.8",
                                marginRight: "-8px",
                              }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Confirmar Contraseña"
                      />
                    </FormControl>

                    <Button
                      variant="contained"
                      startIcon={<CreateIcon />}
                      onClick={registNewUser}
                      disabled={
                        !(
                          registerUser !== null &&
                          registerUser?.name &&
                          registerUser?.pwd &&
                          registerUser?.pwd2
                        )
                      }
                    >
                      Registrar!
                    </Button>
                  </>
                )}
              </Stack>
            </Box>
          </Box>
        </Stack>
      </Paper>
    </Stack>
  );
};
export default UserAccess;
